/**
 * Gestione degli eventi Ajax.
 * Il sistema cerca elementi HTML con attributo data-ajax,
 * il cui valore sarà utilizzato per richiamare l'oggetto
 * appropriato.
 * Questo oggetto si aspetta che abbia tre funzioni:
 * - wait(url, method):
 *   Il metodo eseguito quando la richiesta
 *   sta per venire effettuata, idealmente fornisce
 *   un feedback all'utente per comunicare che
 *   la richiesta è in corso.
 *   Riceve come parametri l'URL della chiamata Ajax
 *   e il metodo della stessa.
 * - done(data, textStatus):
 *   Il metodo eseguito nel caso la chiamata Ajax
 *   sia avvenuta con successo. Questo non significa che
 *   il server abbia compiuto le operazioni dovute,
 *   ma solo che il codice HTTP della risposta è 2xx.
 *   Riceve come parametri un oggetto contenente i dati
 *   della risposta, e lo stato HTTP della stessa.
 * - fail(jqXHR, textStatus):
 *   Il metodo eseguito nel caso la richiesta Ajax
 *   restituisca uno stato non 2xx (come 4xx o 5xx).
 *   Riceve come parametri un oggetto di tipo jqXHR
 *   contenente la richiesta, e il codice
 *   HTTP della risposta.
 *
 * Per registrare un oggetto di callback, usare
 * il template fornito, salvare il file all'interno
 * della cartella "ajax", importarlo e registrarlo
 * all'interno dell'oggetto restituito dalla funzione
 * "loadCallbacks". Per praticità e uniformità,
 * tenere gli elementi dell'elenco in ordine alfabetico.
 */

import login from './ajax/login';
import register from './ajax/register';
import checkoutAthleteData from './ajax/checkout-athlete-data';
import shareAthlete from './ajax/share-athlete';
import shareAthleteEdit from './ajax/share-athlete-edit';
import membershipFederationSelect from './ajax/membership-federation-select';

const loadCallbacks = () => ({
  login,
  register,
  checkoutAthleteData,
  shareAthlete,
  shareAthleteEdit,
  membershipFederationSelect,
});


export default $ => {
  /* eslint no-console: "off" */

  // Ritorna il callback di default con metodi vuoti se in ambiente di produzione.
  const getDefaultCallback = () => (
    window.app.env === 'prod' ? {
      wait() {
      },
      done() {
      },
      fail() {
      },
    } : {
      wait(url, method) {
        console.time();

        console.log(`Ajax request performed to url ${url} with method ${method}`);
      },
      done(data, textStatus) {
        console.timeEnd();

        console.info(data);
        console.info(textStatus);
      },
      fail(jqXHR, textStatus) {
        console.timeEnd();

        console.error(jqXHR);
        console.error(textStatus);
      },
    }
  );


  // Se il callback specificato esiste viene restituito,
  // altrimenti viene creato un oggetto con metodi vuoti.
  const getCallbacks = name => {
    const callbacks = loadCallbacks();

    if (callbacks[name]) {
      return callbacks[name];
    }

    if (window.app.env !== 'prod' && typeof name === 'undefined') {
      console.warn('Attention, Ajax request does not have a name defined in the HTML tag');
    }

    return getDefaultCallback();
  };

  const runCallbacks = (callbacks, url, method, options) => {
    $('.lWaitingOverlay').show();
    callbacks.wait(url, method);

    options.method = method;

    const jqXHR = $.ajax(url, options);

    jqXHR.done(function (data, textStatus, jqXHR) {
      callbacks.done(data, textStatus, jqXHR);
    });

    jqXHR.fail(function (jqXHR, textStatus, errorThrown) {
      callbacks.fail(jqXHR, textStatus, errorThrown);
    });

    jqXHR.always(function () {
      $('.lWaitingOverlay').hide();
    });
  };

  // Intercetta invii form e click su link con attributi data-ajax
  // ed effettua una chiamata Ajax con il metodo specificato (per il form)
  // oppure del tipo definito dall'attributo data-ajax-method per i link.
  $('body').on('submit', 'form[data-ajax]', function (event) {
    event.preventDefault();

    const callbacks = getCallbacks($(this).data('ajax'));
    const url = $(this).attr('action');
    const method = $(this).attr('method');
    runCallbacks(callbacks, url, method, {data: $(this).serialize()});
    return false;
  });

  $('body').on('click', 'a[data-ajax]', function (event) {
    event.preventDefault();

    const callbacks = getCallbacks($(this).data('ajax'));
    const url = $(this).attr('href');
    let method = $(this).data('ajax-method');
    method = method || 'GET';
    runCallbacks(callbacks, url, method, {});
    return false;
  });

  $('body').on('change', 'select[data-ajax]', function () {
    const callbacks = getCallbacks($(this).data('ajax'));

    const url = $(this).data('ajax-url');

    let method = $(this).data('ajax-method');
    method = method || 'GET';

    let param = $(this).data('ajax-param');
    param = param || 'value';

    let data = {};
    data[param] = $(this).val();

    runCallbacks(callbacks, url, method, {data});
  });

  $('select[data-ajax]').trigger('change');
};



// WEBPACK FOOTER //
// ./assets/js/component/ajax.js